<!-- backIssueBrowsing -->
<template>
  <div class="backIssueBrowsing">
    <el-form-item label="过刊浏览：" prop="backIssueBrowsing">
      <el-input v-model="ruleForm.backIssueBrowsing" type="text" class="fl" style="width: 50%;" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'backIssueBrowsing',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
